export default __webpack_public_path__ + "static/media/banner-8.36b9cdc3.jpg";